/* unplugin-vue-components disabled */import { render } from "./content-editable.vue?vue&type=template&id=0d2959cf&scoped=true"
import script from "./content-editable.vue?vue&type=script&lang=js"
export * from "./content-editable.vue?vue&type=script&lang=js"

import "./content-editable.vue?vue&type=style&index=0&id=0d2959cf&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2959cf"],['__file',"src/components/content-editable/content-editable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d2959cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d2959cf', __exports__)) {
    api.reload('0d2959cf', __exports__)
  }
  
  module.hot.accept("./content-editable.vue?vue&type=template&id=0d2959cf&scoped=true", () => {
    api.rerender('0d2959cf', render)
  })

}


export default __exports__